import styled from "styled-components";
import { FooterNovoConhecerContainerProps } from "./FooterNovoConhecer.types";

export const FooterNovoConhecerContainer = styled.footer<FooterNovoConhecerContainerProps>`
  background-color: ${(props: { $backgroundcolor: string }) =>
    props.$backgroundcolor};
    position: relative;
    z-index: 2;

.footerNovoConhecer__container{

    position: relative;
    padding-bottom: 70px;

    @media (min-width: 769px) {
      padding-bottom: 0px;
    }
}

.footerNovoConhecer__container p:last-child {
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
    margin-top: 20px;
    padding-bottom: 60px;
  }
`;

